$(document).ready(function() {
  // BOM form in admin dashboard
  $("#bom-category").change(function(){
    var group_code = $(this).val();
    updateLanguage(group_code);
  });

  $("#month-range").change(function(){
    updateCodes();
  });

  function updateLanguage(group_code){
    var lang     = $("#group-codes").attr("data-codes");
    var obj_lang = JSON.parse(lang);
    var category = obj_lang[group_code].split("-");

    $("#language").val(category[0]);
    $("#group-code").val(category[1]);
    updateCodes();
  }

  function updateCodes(){
    var group_code = $("#group-code").val();
    var quarter    = $("#month-range").val();
    var language   = $("#language").val();
    var item_code  = group_code + quarter
    var bom_code   = "BOM" + quarter
    var title      = language + " " + " Batch " + quarter.replace("Q", "")

    $("#item-code").val(item_code);
    $("#bom-code").val(bom_code);
    $("#title").val(title);
  }

  var requiredCheckboxes = $('.custom-checkbox :checkbox[required]');
  requiredCheckboxes.change(function(){
    if(requiredCheckboxes.is(':checked')) {
      requiredCheckboxes.removeAttr('required');
    } else {
      requiredCheckboxes.attr('required', 'required');
    }
  });
});
